module.exports = __webpack_public_path__ + "img/vertical_6_1_3.942fea3c.png";